import PropTypes from "prop-types";
import React, { useCallback, useEffect, useState } from "react";

//Import Scrollbar
import SimpleBar from "simplebar-react";
import graphBlack from "../../assets/images/restaurant-portal/graph-black.svg";
import graphOrange from "../../assets/images/restaurant-portal/graph-orange.svg";
import peopleBlack from "../../assets/images/restaurant-portal/people-black.svg";
import peopleOrange from "../../assets/images/restaurant-portal/people-orange.svg";
import coinBlack from "../../assets/images/restaurant-portal/coin-black.svg";
import coinOrange from "../../assets/images/restaurant-portal/coin-orange.svg";
import settingOutline from "../../assets/images/sidebar/setting-outline.svg";
import settingOrange from "../../assets/images/sidebar/setting-orange.svg";
import logoutOutline from "../../assets/images/sidebar/logout-outline.svg";
import logoutOrange from "../../assets/images/sidebar/logout-orange.svg";
import ticketStarOutline from "../../assets/images/sidebar/ticket-star-outline.svg";
import ticketStarOrange from "../../assets/images/sidebar/ticket-star-orange.svg";

// MetisMenu
import MetisMenu from "metismenujs";
import withRouter from "../Common/withRouter";
import { Link, useLocation } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";

// API
import { post } from "../../api/axios";
import endpoints from "../../api/endpoints";

// Utils
import { extractErrorMessage } from "../../utils/errorHandler";

// Toast notifications
import toastr from "toastr";
import "toastr/build/toastr.min.css";

const RestaurantSidebarContent = (props) => {
  const [hoveredItem, setHoveredItem] = useState(null);
  const [focusedItem, setFocusedItem] = useState(null);

  // Configure toastr options
  toastr.options = {
    positionClass: "toast-bottom-left",
    timeOut: 5000,
    closeButton: true,
    progressBar: true,
  };

  const activateParentDropdown = useCallback((item) => {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      return false;
    }
    return false;
  }, []);

  const removeActivation = (items) => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;

      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.length && parent.childNodes[1]
            ? parent.childNodes[1]
            : null;
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show");
        }

        parent.classList.remove("mm-active");
        const parent2 = parent.parentElement;

        if (parent2) {
          parent2.classList.remove("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove("mm-active"); // li
            parent3.childNodes[0].classList.remove("mm-active");

            const parent4 = parent3.parentElement; // ul
            if (parent4) {
              parent4.classList.remove("mm-show"); // ul
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove("mm-show"); // li
                parent5.childNodes[0].classList.remove("mm-active"); // a tag
              }
            }
          }
        }
      }
    }
  };

  const path = useLocation();
  const activeMenu = useCallback(() => {
    const pathName = path.pathname;
    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu");
    const items = ul.getElementsByTagName("a");
    removeActivation(items);

    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  }, [path.pathname, activateParentDropdown]);

  const isActive = (pathname) => {
    return path.pathname === pathname;
  };

  const handleLogout = async (e) => {
    e.preventDefault();
    try {
      await post(endpoints.restaurantLogout, {});
      localStorage.removeItem("accessToken");
      localStorage.removeItem("user");
      toastr.success("Logged out successfully!");
      props.router.navigate("/login");
    } catch (error) {
      const errorMessage = extractErrorMessage(error);
      toastr.error(errorMessage);
    }
  };

  useEffect(() => {
    new MetisMenu("#side-menu");
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    activeMenu();
  }, [activeMenu]);

  return (
    <React.Fragment>
      <div className="sidebar-wrapper">
        <SimpleBar style={{ maxHeight: "calc(100% - 120px)" }}>
          <div id="sidebar-menu">
            <ul className="metismenu list-unstyled" id="side-menu">
              <li>
                <Link
                  to="/restaurant/settlements"
                  className="waves-effect"
                  onMouseEnter={() => setHoveredItem("settlements")}
                  onMouseLeave={() => setHoveredItem(null)}
                  onFocus={() => setFocusedItem("settlements")}
                  onBlur={() => setFocusedItem(null)}
                >
                  <img
                    src={
                      isActive("/restaurant/settlements") ||
                      hoveredItem === "settlements" ||
                      focusedItem === "settlements"
                        ? coinOrange
                        : coinBlack
                    }
                    alt="settlements"
                  />
                  <span>{props.t("Settlements")}</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/restaurant/redemptions"
                  className="waves-effect"
                  onMouseEnter={() => setHoveredItem("redemptions")}
                  onMouseLeave={() => setHoveredItem(null)}
                  onFocus={() => setFocusedItem("redemptions")}
                  onBlur={() => setFocusedItem(null)}
                >
                  <img
                    src={
                      isActive("/restaurant/redemptions") ||
                      hoveredItem === "redemptions" ||
                      focusedItem === "redemptions"
                        ? ticketStarOrange
                        : ticketStarOutline
                    }
                    alt="redemptions"
                  />
                  <span>{props.t("Redemptions")}</span>
                </Link>
              </li>{" "}
              <li>
                <Link
                  to="/restaurant/customers"
                  className="waves-effect"
                  onMouseEnter={() => setHoveredItem("customers")}
                  onMouseLeave={() => setHoveredItem(null)}
                  onFocus={() => setFocusedItem("customers")}
                  onBlur={() => setFocusedItem(null)}
                >
                  <img
                    src={
                      isActive("/restaurant/customers") ||
                      hoveredItem === "customers" ||
                      focusedItem === "customers"
                        ? peopleOrange
                        : peopleBlack
                    }
                    alt="customers"
                  />
                  <span>{props.t("Customers")}</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/restaurant/market-insights"
                  className="waves-effect"
                  onMouseEnter={() => setHoveredItem("market-insights")}
                  onMouseLeave={() => setHoveredItem(null)}
                  onFocus={() => setFocusedItem("market-insights")}
                  onBlur={() => setFocusedItem(null)}
                >
                  <img
                    src={
                      isActive("/restaurant/market-insights") ||
                      hoveredItem === "market-insights" ||
                      focusedItem === "market-insights"
                        ? graphOrange
                        : graphBlack
                    }
                    alt="market-insights"
                  />
                  <span>{props.t("Customer Insights")}</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/restaurant/staff"
                  className="waves-effect"
                  onMouseEnter={() => setHoveredItem("staff")}
                  onMouseLeave={() => setHoveredItem(null)}
                  onFocus={() => setFocusedItem("staff")}
                  onBlur={() => setFocusedItem(null)}
                >
                  <img
                    src={
                      isActive("/restaurant/staff") ||
                      hoveredItem === "staff" ||
                      focusedItem === "staff"
                        ? peopleOrange
                        : peopleBlack
                    }
                    alt="staff"
                  />
                  <span>{props.t("Staff")}</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/restaurant/profile/activity-logs"
                  className="waves-effect"
                  onMouseEnter={() => setHoveredItem("activity-logs")}
                  onMouseLeave={() => setHoveredItem(null)}
                  onFocus={() => setFocusedItem("activity-logs")}
                  onBlur={() => setFocusedItem(null)}
                >
                  <img
                    src={
                      isActive("/restaurant/profile/activity-logs") ||
                      hoveredItem === "activity-logs" ||
                      focusedItem === "activity-logs"
                        ? graphOrange
                        : graphBlack
                    }
                    alt="activity-logs"
                  />
                  <span>{props.t("Activity Logs")}</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/restaurant/settings"
                  className="waves-effect"
                  onMouseEnter={() => setHoveredItem("settings")}
                  onMouseLeave={() => setHoveredItem(null)}
                  onFocus={() => setFocusedItem("settings")}
                  onBlur={() => setFocusedItem(null)}
                >
                  <img
                    src={
                      isActive("/restaurant/settings") ||
                      hoveredItem === "settings" ||
                      focusedItem === "settings"
                        ? settingOrange
                        : settingOutline
                    }
                    alt="settings"
                  />
                  <span>{props.t("Settings")}</span>
                </Link>
              </li>
            </ul>
          </div>
        </SimpleBar>
        <div className="sidebar-footer">
          <Link
            to="/logout"
            className="sidebar-logout-btn"
            onMouseEnter={() => setHoveredItem("logout")}
            onMouseLeave={() => setHoveredItem(null)}
            onFocus={() => setFocusedItem("logout")}
            onBlur={() => setFocusedItem(null)}
            onClick={handleLogout}
          >
            <img
              src={
                hoveredItem === "logout" || focusedItem === "logout"
                  ? logoutOrange
                  : logoutOutline
              }
              alt="logout"
            />
            <span>{props.t("Logout")}</span>
          </Link>
        </div>
      </div>
    </React.Fragment>
  );
};

RestaurantSidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(RestaurantSidebarContent));
